"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportIssues = exportIssues;
exports.universalExport = universalExport;
exports.jUnitXmlExport = jUnitXmlExport;
exports.userFlowExport = userFlowExport;
const csv_axe_devtools_1 = __importDefault(require("./formats/csv-axe-devtools"));
const csv_axe_reports_1 = __importDefault(require("./formats/csv-axe-reports"));
const j_unit_xml_1 = __importDefault(require("./formats/j-unit-xml"));
const json_axe_devtools_1 = __importDefault(require("./formats/json-axe-devtools"));
const json_ufa_1 = require("./formats/json-ufa");
const json_universal_1 = __importDefault(require("./formats/json-universal"));
function unknownFormat(format) {
    throw new Error(`Unknown export format: ${format}`);
}
function issuesTransformer(issues, format, options) {
    switch (format) {
        case 'json':
            return (0, json_axe_devtools_1.default)(issues, options);
        case 'csv-axe-devtools':
            return (0, csv_axe_devtools_1.default)(issues, options);
        case 'csv-axe-reports':
            return (0, csv_axe_reports_1.default)(issues);
        default:
            return unknownFormat(format);
    }
}
function createExport(filename, dataString, type) {
    const data = new Blob([dataString], { type });
    const url = window.URL.createObjectURL(data);
    const tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', filename);
    tempLink.click();
}
async function exportIssues({ filename, issues, format, options }) {
    const exportString = await issuesTransformer(issues, format, options);
    const mimeType = format === 'json' ? 'application/json' : 'text/csv';
    createExport(filename, exportString, mimeType);
}
function universalExport({ filename, test, manifests, issues, additionalProperties }) {
    const data = (0, json_universal_1.default)(test, manifests, issues, additionalProperties, 'string');
    createExport(filename, data, 'application/json');
}
function jUnitXmlExport({ filename, issues, additionalProperties }) {
    const data = (0, j_unit_xml_1.default)(issues, additionalProperties);
    createExport(filename, data, 'application/json');
}
function userFlowExport({ filename, userFlow, results, additionalProperties }) {
    const data = (0, json_ufa_1.jsonUFA)(userFlow, results, additionalProperties);
    createExport(filename, data, 'application/json');
}
//# sourceMappingURL=export.js.map